export default __webpack_public_path__ + "static/media/Green and Orange Vintage Horror Halloween Poster.bfc50f64.jpg";